import { render, staticRenderFns } from "./BoxShadowCSS.vue?vue&type=template&id=4adb9d35&scoped=true&"
import script from "./BoxShadowCSS.vue?vue&type=script&lang=js&"
export * from "./BoxShadowCSS.vue?vue&type=script&lang=js&"
import style0 from "./BoxShadowCSS.vue?vue&type=style&index=0&id=4adb9d35&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4adb9d35",
  null
  
)

export default component.exports